<template>
  <div id="contenedor-editar-contrato-tema">
    <v-card>
      <v-card-title class="secondary--text">
          Editar Tema
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
      <v-card-text>
        <v-form v-model="formularioValido" ref="actualizarContratoTema">
          <v-row>
            <v-col cols="12">
              <TextField
                v-model="tema.clave"
                label="Clave">
              </TextField>
            </v-col>
            <v-col cols="12">
              <TextArea
                v-model="tema.descripcion"
                label="Descripción"
                rows="2"
              >
              </TextArea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixActualizarTema"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Actualizar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixTemasContrato from './mixTemasContrato';
import TextField from '@/components/inputs/sinColumnas/TextField.vue';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarContratoTema',
  mixins: [mixTemasContrato],
  components: {
    TextArea,
    TextField,
    CustomButton,
  },
  props: {
    contratoTemaEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tema: {
        clave: this.contratoTemaEditar.clave,
        descripcion: this.contratoTemaEditar.descripcion,
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.actualizarContratoTema.reset();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss"></style>
